import React, { useMemo } from 'react';
import { useNotifier } from '../../context/NotificationContext';
import DataTable from '../../components/common/DataTable';
import { createResourceService } from '../../services/api.service';
import { FiDownload } from 'react-icons/fi';

const payslipsService = createResourceService('employee-portal/payslips');

const MyPayslips = () => {
    const { notify } = useNotifier();

    const handleDownload = (fileUrl) => {
        if (!fileUrl) {
            notify({ message: 'No PDF available for this payslip yet.', style: 'warning' });
            return;
        }
        window.open(fileUrl, '_blank');
    };

    const tableColumns = useMemo(() => [
        {
            key: 'period', label: 'Period', type: 1, sortable: false, render: (item) => (
                <div style={{ fontWeight: '600' }}>
                    {item.period_start ? new Date(item.period_start).toLocaleDateString([], {month: 'short', day: 'numeric'}) : '-'} 
                    &nbsp;-&nbsp; 
                    {item.period_end ? new Date(item.period_end).toLocaleDateString([], {month: 'short', day: 'numeric', year: 'numeric'}) : '-'}
                </div>
            )
        },
        { key: 'base_salary', label: 'Base Salary', type: 1, sortable: true, render: (item) => `$${parseFloat(item.base_salary || 0).toFixed(2)}` },
        { key: 'bonuses', label: 'Bonuses', type: 1, sortable: true, render: (item) => <span style={{ color: '#10b981' }}>+${parseFloat(item.bonuses || 0).toFixed(2)}</span> },
        { key: 'deductions', label: 'Deductions', type: 1, sortable: true, render: (item) => <span style={{ color: '#ef4444' }}>-${parseFloat(item.deductions || 0).toFixed(2)}</span> },
        { key: 'net_pay', label: 'Net Pay', type: 1, sortable: true, render: (item) => <span style={{ fontWeight: '700' }}>${parseFloat(item.net_pay || 0).toFixed(2)}</span> }
    ], []);

    const config = {
        title: (
            <span>
                <h2>My Payslips</h2>
                <p>View and download your official salary statements.</p>
            </span>
        ),
        searchables: ['period_start', 'period_end'],
        add: false,
        edit: false,
        delete: false,
        archive: false,
        rowActions: [
            {
                text: 'Download PDF',
                icon: FiDownload,
                type: 'button',
                className: 'button icon btn-outlined',
                onClick: (item) => handleDownload(item.file_url)
            }
        ]
    };

    return (
        <DataTable
            resourceName="my-payslips"
            apiService={payslipsService}
            columns={tableColumns}
            config={config}
        />
    );
};

export default MyPayslips;
